import React from 'react'

import ProductSelector from '../../product-selector'

function StoryblokProductSelectorAdapter(props) {
  return <ProductSelector {...props} />
}

export default StoryblokProductSelectorAdapter
